import { render, staticRenderFns } from "./Service_charge.vue?vue&type=template&id=145c23c4&scoped=true"
import script from "./Service_charge.vue?vue&type=script&setup=true&lang=js"
export * from "./Service_charge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Service_charge.vue?vue&type=style&index=0&id=145c23c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145c23c4",
  null
  
)

export default component.exports